<template>
  <v-tabs class="pl-1" style="position: relative; max-width: 100px;" :hide-slider="true">
    <v-tab class="px-3 rounded-tab" :class="ShowOtherTemplates ? 'flowout' : ''" style="min-width: unset;"
      @click="ShowOtherTemplates = !ShowOtherTemplates">
      <v-icon size="20" :color="ShowOtherTemplates ? 'tertiary' : 'rgba(0, 0, 0, 0.54)'">
        mdi-format-list-bulleted-square
      </v-icon>
    </v-tab>
  </v-tabs>
</template>


<script>

export default {
  name: 'OtherTemplatesListButton',
  components: {},
  mixins: [],

  data() {
    return {
    };
  },

  methods: {},

  computed: {
    ShowOtherTemplates: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("ShowOtherTemplates");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "ShowOtherTemplates", value: update });
      },
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped></style>